import {ReportDownloadModel} from "@/model/ReportDownloadModel";
import {ReportDownload} from "@/scripts/Common/ReportDownload";
import {CrudManager} from "@/scripts/ProfiControlRequests/CrudManager";

export class ReportRequester {

    public static DownloadReport(url:string, token:string, fileModel:ReportDownloadModel, language:string) : void
    {
        CrudManager.Get(url, token, language)
            .then((response) => {
                if (response.data) {
                    fileModel.Data = response.data
                    ReportDownload.Create(fileModel);
                }
            })
            .catch(_=>{});
    }
}
